import { render, staticRenderFns } from "./CbxAssetClassification.vue?vue&type=template&id=71b495e6&"
import script from "./CbxAssetClassification.vue?vue&type=script&lang=ts&"
export * from "./CbxAssetClassification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports